// generated by srcset-codegen
import src from "./ex.svg";

const width = 12;
const height = 11;
export default { src, width, height };
